module.exports = __webpack_public_path__ + "img/fedding4.3e735225.png";